/* eslint-disable react/no-unescaped-entities */
import Head from "next/head";
import { useTheme } from "next-themes";
import { FiFileText } from "react-icons/fi";
import Link from "next/link";
import { FaGithub } from "react-icons/fa";
import Image from "next/image";
import aizen from "../../public/work/aizen.png";

export default function Work1() {
  const { systemTheme, theme, setTheme } = useTheme();
  const currentTheme = theme === "system" ? systemTheme : theme;

  return (
    <div className="px-10 sm:px-20 md:px-32 lg:mb-12 lg:px-60 mx-auto max-w-[75rem]">
      <Head>
        <title>{process.env.NEXT_PUBLIC_WORK_1_LINK_TITLE ? process.env.NEXT_PUBLIC_WORK_1_LINK_TITLE : ""}</title>
        <link rel="icon" href="/favicon.png" />
      </Head>
      <main className="  max-w-screen ">
        <div className=" mx-auto pt-16 -pb-10 max-w-7xl">
          {
            process.env.NEXT_PUBLIC_WORK_1_TITLE && (
              <div className=" mx-auto flex flex-col text-center justify-center">
                <h1
                  className={`mt-6 mb-12 font-deca bg-gradient-to-bl from-indigo-900 via-indigo-400 to-indigo-900 bg-clip-text text-transparent selection:text-gray-700 dark:selection:text-white/90 items-center mx-auto text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold`}
                >
                  {process.env.NEXT_PUBLIC_WORK_1_TITLE}
                </h1>
              </div>
            )
          }
          {
            process.env.NEXT_PUBLIC_WORK_1_LINK_SUBHEADING && (
              <div className="mx-auto flex flex-col text-center justify-center">
                <h4
                  className={`mb-12 font-deca bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gray-300 via-fuchsia-600 to-orange-600 bg-clip-text text-transparent selection:text-gray-700 dark:selection:text-white/90 items-center mx-auto text-base md:text-lg lg:text-lg xl:text-lg font-bold`}
                >
                  {process.env.NEXT_PUBLIC_WORK_1_LINK_SUBHEADING}
                </h4>
              </div>
            )
          }
          <div className="flex justify-center space-x-3 md:space-x-6 lg:space-x-8 items-center  my-4">
            {
              process.env.NEXT_PUBLIC_WORK_1_LINK_LIVELINK && (
                <div className="group border-purple-400 hover:bg-purple-400 hover:text-white hover:drop-shadow-2xl text-purple-500 rounded-md md:rounded-xl px-2 py-1 md:px-4 md:py-2 shadow-md drop-shadow-lg dark:bg-purple-400 dark:shadow-none dark:hover:shadow-white select-none dark:text-white shadow-purple-300 ">
                  <Link
                    href={process.env.NEXT_PUBLIC_WORK_1_LINK_LIVELINK}
                    target="_blank"
                    className="flex items-center font-normal lg:font-bold space-x-2 text-sm md:text-base"
                  >
                    <FiFileText className="dark:stroke-white stroke-purple-400 stroke-2 group-hover:stroke-white " />
                    <p>Live</p>
                  </Link>
                </div>
              )
            }
            {
              process.env.NEXT_PUBLIC_WORK_1_LINK_CODELINK && (
                <div className=" group border-blue-400 hover:bg-blue-400 text-blue-500 hover:text-white hover:drop-shadow-2xl rounded-md md:rounded-xl px-2 py-1 md:px-4 md:py-2 shadow-md drop-shadow-lg dark:bg-blue-400 dark:shadow-none dark:hover:shadow-white select-none dark:text-white shadow-blue-300">
                  <Link
                    href={process.env.NEXT_PUBLIC_WORK_1_LINK_CODELINK}
                    target="_blank"
                    className="flex items-center font-normal lg:font-bold space-x-2 text-sm md:text-base  "
                  >
                    <FaGithub className=" dark:stroke-white stroke-blue-400 stroke-2 group-hover:stroke-white " />
                    <p>Code</p>
                  </Link>
                </div>
              )
            }
          </div>
          {
            process.env.NEXT_PUBLIC_WORK_1_LINK_MAIN_CONTENT && (
              <div className=" mx-auto flex flex-col ">
                <div
                  className={`mt-10 only:mb-12 font-deca bg-gradient-to-br bg-clip-text selection:text-gray-700 dark:selection:text-white/90 items-center mx-auto text-sm md:text-lg lg:text-lg xl:text-lg `}
                  dangerouslySetInnerHTML={{ __html: process.env.NEXT_PUBLIC_WORK_1_LINK_MAIN_CONTENT }}
                />
              </div>
            )
          }
          <Image
            loading="lazy"
            src={aizen}
            alt=""
            width="max"
            className="drop-shadow-2xl mt-10"
          />
        </div>
      </main>
    </div>
  );
}
